import React from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../i18n';

const About = () => {
  return (
    <div className="bg-warm-white text-slate-700"> {/* Changed bg-slate-50 to bg-warm-white */}
      {/* Hero Section - Reverted to original theme */}
      <section className="relative pt-24 pb-16 bg-gradient-earth overflow-hidden">{/* Reverted to bg-gradient-earth */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-10 w-32 h-32 bg-white rounded-full"></div>
          <div className="absolute bottom-20 left-10 w-24 h-24 bg-white rounded-full"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <span className="block text-sm sm:text-base font-medium text-green-200 uppercase tracking-wider mb-3 sm:mb-4"> {/* Reverted text color */}
            Meet Your Practitioner
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold font-display text-white mb-6"> {/* Ensured text-white, kept font-display from original */}
            {i18n.about_us}
          </h1>
          <p className="text-lg sm:text-xl text-blue-100 mx-auto leading-relaxed"> {/* Reverted text color */}
            Dedicated to bringing the ancient wisdom of Ayurveda to modern wellness, fostering balance and vitality.
          </p>
        </div>
      </section>

      {/* Main Content Area */}
      <main className="py-12 md:py-20">
        <div className="max-w-6xl mx-auto px-6 space-y-16 md:space-y-24">

          {/* Practitioner & Location Section */}
          <section className="grid md:grid-cols-5 gap-8 md:gap-12 items-start">
            {/* Practitioner Profile Card */}
            <div className="h-full md:col-span-3 bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-6">
                <img
                  src="https://i.ibb.co/JjFSkpj/tejal.png"
                  alt="Tejal Swami"
                  className="w-32 h-32 sm:w-36 sm:h-36 rounded-full object-cover border-4 border-sage shadow-md" // Changed border-emerald-500 to border-sage
                />
                <div className="flex-1">
                  <h2 className="text-3xl font-semibold text-primary-dark mb-1 font-display"> {/* Changed text-emerald-800 to text-primary-dark, font-serif to font-display */}
                    Tejal Swami
                  </h2>
                  <p className="text-md text-primary font-medium mb-4"> {/* Changed text-teal-600 to text-primary */}
                    Certified Ayurvedic Practitioner & Wellness Educator
                  </p>
                  <div className="space-y-2 text-sm text-gray-600 mb-6"> {/* Changed text-slate-600 to text-gray-600 */}
                    <p><span className="text-secondary mr-2">🎓</span>Bachelor's in Psychology - UC Santa Barbara</p> {/* Changed text-emerald-600 to text-secondary */}
                    <p><span className="text-secondary mr-2">🏥</span>Certified Ayurvedic Practitioner - SCUHS</p> {/* Changed text-emerald-600 to text-secondary */}
                    <p><span className="text-secondary mr-2">⏰</span>2+ Years Clinical Internship</p> {/* Changed text-emerald-600 to text-secondary */}
                    <p><span className="text-secondary mr-2">📍</span>Based in Ventura, California</p> {/* Changed text-emerald-600 to text-secondary */}
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3 justify-center sm:justify-start w-full">
                    <a
                      href="https://www.fresha.com/providers/swami-ayurveda-ia5mxbwa?allOffer=true"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-primary text-center py-2.5 px-6 rounded-lg font-semibold no-underline flex-1 sm:flex-none whitespace-nowrap"
                    >
                      Book Consultation
                    </a>
                    <a
                      href="mailto:tejal@swami.life"
                      className="btn-secondary text-center py-2.5 px-6 rounded-lg font-semibold no-underline flex-1 sm:flex-none whitespace-nowrap"
                    >
                      Send Email
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact & Map Card */}
            <div className="h-full md:col-span-2 bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-primary-dark mb-4 font-display border-b pb-2 border-slate-200"> {/* Changed text-emerald-800 to text-primary-dark, font-serif to font-display */}
                Visit Our Wellness Center
              </h3>
              <div className="space-y-3 text-sm">
                <div>
                  <strong className="text-primary block">Address:</strong> {/* Changed text-teal-700 to text-primary */}
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=2021+Sperry+Avenue+Suite+18+Ventura+CA+93003"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:text-primary-dark transition-colors no-underline"
                  >
                    Holistic Healing Center <br />2021 Sperry Avenue Suite 18, Ventura, CA 93003
                  </a>
                </div>
                <div>
                  <strong className="text-primary block">Hours:</strong> {/* Changed text-teal-700 to text-primary */}
                  <p className="text-gray-600">By Appointment Only</p> {/* Changed text-slate-600 to text-gray-600 */}
                </div>
                <div>
                  <strong className="text-primary block">Email:</strong> {/* Changed text-teal-700 to text-primary */}
                  <a href="mailto:tejal@swami.life" className="text-primary hover:text-primary-dark transition-colors no-underline"> {/* Changed text-emerald-600 to text-primary */}
                    tejal@swami.life
                  </a>
                </div>
                <div>
                  <strong className="text-primary block">Booking:</strong> {/* Changed text-teal-700 to text-primary */}
                  <a
                    href="https://www.fresha.com/providers/swami-ayurveda-ia5mxbwa?allOffer=true"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:text-primary-dark transition-colors no-underline" // Changed text-emerald-600 to text-primary
                  >
                    Online Scheduling
                  </a>
                </div>
              </div>
              {/* Map removed as per request */}
            </div>
          </section>

          {/* Biography Section */}
          <section className="bg-white p-6 sm:p-10 rounded-xl shadow-lg">
            <h2 className="text-3xl font-semibold text-primary-dark mb-6 text-center font-display"> {/* Changed text-emerald-800 to text-primary-dark, font-serif to font-display */}
              A Journey to Holistic Healing
            </h2>
            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-5"> {/* Changed text-slate-600 to text-gray-700 */}
              <p>
                Tejal Swami is a passionate advocate and practitioner of Ayurvedic Medicine. She received her Bachelor's in Psychology at the University of California, Santa Barbara and from there pursued her certification as an Ayurvedic Wellness Educator and Ayurvedic Practitioner at Southern California University of Health Sciences where she underwent a two-year clinical internship with intensive training on consultations, herbs, and treatments.
              </p>
              <p>
                Since childhood, Tejal had always been interested in the medical field. As she learned more about our current health system she realized that it not only lacked expertise in preventing disease, but it failed to treat an individual as an interconnected whole. Her desire to provide a more holistic and preventative approach to healing took Tejal back to her traditional Indian roots and into the depths of Ayurvedic Medicine.
              </p>
              <p>
                Tejal currently resides in Ventura, California where her experience with and practice of Ayurvedic Medicine guides her to spread the holistic healing wisdom of Ayurveda through clinical practice and other public outlets. She encourages individuals to explore a holistic approach to treating the mind and body through Ayurveda; she believes that Ayurveda has the means to provide a higher and healthier quality of life, something everyone deserves.
              </p>
            </div>
          </section>

          {/* Philosophy Section */}
          <section className="bg-white p-6 sm:p-10 rounded-xl shadow-lg"> {/* Changed bg-emerald-50 to bg-cream */}
            <h2 className="text-3xl font-semibold text-primary-dark mb-8 text-center font-display"> {/* Changed text-emerald-800 to text-primary-dark, font-serif to font-display */}
              Our Treatment Philosophy
            </h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
                          {[
                            { icon: '🌱', title: 'Holistic Approach', desc: 'Treating the whole person, not just symptoms.', bgColor: 'bg-cream' },
                            { icon: '⚖️', title: 'Preventative Care', desc: 'Focus on maintaining health and preventing disease.', bgColor: 'dosha-vata' },
                            { icon: '🎯', title: 'Personalized Treatment', desc: 'Customized based on individual constitution.', bgColor: 'dosha-pitta' },
                            { icon: '🌿', title: 'Natural Methods', desc: 'Using time-tested natural healing practices.', bgColor: 'dosha-kapha' },
                          ].map((item, index) => (
                            <div key={index} className={`${item.bgColor} p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center`}>
                              <span className="text-4xl mb-3 inline-block text-secondary">{item.icon}</span> {/* Added text-secondary to icon */}
                              <h4 className="text-lg font-semibold text-primary mb-1">{item.title}</h4> {/* Changed text-teal-700 to text-primary */}
                              <p className="text-sm text-gray-600">{item.desc}</p> {/* Changed text-slate-600 to text-gray-600 */}
                            </div>
                          ))}
                        </div>
          </section>

          {/* CTA Section */}
          <section className="text-center">
            <div className="bg-primary-light text-white p-8 sm:p-12 rounded-xl shadow-xl"> {/* Changed gradient to bg-primary */}
              <h3 className="text-white text-2xl sm:text-3xl font-bold mb-4 font-display"> {/* font-serif to font-display */}
                Ready to Start Your Wellness Journey?
              </h3>
              <p className="text-blue-100 mb-8 mx-auto text-lg"> {/* Changed text-emerald-100 to text-blue-100 */}
                Experience personalized Ayurvedic care designed to restore balance and vitality to your life.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://www.fresha.com/providers/swami-ayurveda-ia5mxbwa?allOffer=true"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-gold text-lg px-8 py-3 rounded-full font-display no-underline" // Used btn-gold class
                >
                  Schedule Consultation
                </a>
                <Link
                  to="/services"
                  className="btn-primary text-white border-white hover:bg-white hover:text-primary text-lg px-8 py-3 rounded-full font-display" // Used btn-secondary with appropriate styling for this context
                >
                  Explore Services
                </Link>
              </div>
            </div>
          </section>

        </div>
      </main>
    </div>
  );
};

export default About;
